import { render, staticRenderFns } from "./ImportLakala.vue?vue&type=template&id=7ab7e1f6"
import script from "./ImportLakala.vue?vue&type=script&lang=js"
export * from "./ImportLakala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports